
import { Box } from '@mui/material';
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import BaseCard from '../../../components/Cards/Card';
import CustomEmailInput from '../../../components/EmailInput';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormik } from 'formik';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import { BASE_URL } from '../../../components/BaseUrl';
import { useState } from 'react';
import { setOtpData } from '../../../Redux/Slices/AuthSlice';
import { useDispatch } from 'react-redux';
const ForgetPassword = () => {
  const theme = useTheme();
  const { t,i18n } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
const dispatch = useDispatch();
  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = t('forgetPassword.emailRequired');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      errors.email = t('forgetPassword.emailInvalid');
    }
    return errors;
  };

const handleSubmit = async (values) => {
  const errors = validate(values);
  if (Object.keys(errors).length > 0) {
    if (errors.email) toast.error(errors.email);
    return;
  }

  setLoading(true);

  try {
    const response = await fetch(`${BASE_URL}/public/worker/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: values.email }),
    });

    const data = await response.json();
    console.log("📩 Forget password API response:", data);

    if (!response.ok || data.error) {
      throw new Error(data.message || "Something went wrong");
    }
const message =
i18n.language === "es"
? data.message_es
: data.message_en;
    toast.success(message || "OTP sent successfully");

    // ✅ Save OTP + email in Redux & LocalStorage (optional)
    dispatch(
      setOtpData({
        email: values.email,
        otp: data.data?.otp, // depends on backend response
      })
    );
    localStorage.setItem("forgetEmail", values.email);
    localStorage.setItem("forgetOtp", data.data?.otp);

    // ✅ Navigate to verification screen
    setTimeout(() => {
     navigate(`/verification?email=${values.email}`);
    }, 1500);
  } catch (error) {
    console.error("🚨 Forget Password error:", error);
    toast.error(error.message || "Failed to send OTP");
  } finally {
    setLoading(false);
  }
};

  const formik = useFormik({
    initialValues: { email: '' },
    validate,
    onSubmit: handleSubmit,
  });

  return (
    <Box sx={{ backgroundColor: "#EFF4F8", mt: 0, pt: 0, height: "100vh" }}>
      <Toaster />
      <Box sx={{ px: 2, display: 'flex', justifyContent: 'center',
             minHeight: "100vh",
              alignItems: "center",
           }}>
        <BaseCard
          maxWidth={isMobile ? '100%' : 380}
          sx={{
            width: isMobile ? '100%' : 'auto',
            boxSizing: 'border-box',
            px: isMobile ? 2 : 0,
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
                <CustomText sx={{ ...textStyles.h4, color: theme.palette.tertiary.main, letterSpacing: "0px !important" }}>
                  {t('forgetPassword.title')}
                </CustomText>
                <CustomText customStyle={{ ...textStyles.body4, color: theme.palette.text.primary, letterSpacing: "0px !important" }}>
                  {t('forgetPassword.subtitle')}
                </CustomText>
              </Box>

              <label className='email_label'>{t('forgetPassword.emailLabel')}</label>
              <CustomEmailInput
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && formik.errors.email}
              />
              {formik.touched.email && formik.errors.email && (
                <span style={{ color: 'red', fontSize: '12px' }}>{formik.errors.email}</span>
              )}

              <CustomButton
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                       {loading && <CircularProgress size={18} sx={{ color: '#fff', mr: 1 }} />}
                    {t('forgetPassword.submitButton')}
                 
                  </Box>
                }
                type="submit"
                fullWidth
                sx={{ mt: 2 }}
              />
            </Box>
          </form>
        </BaseCard>
      </Box>
    </Box>
  );
};

export default ForgetPassword;
